<template>
    <div class="modal-card card">
        <form @submit.prevent="deleteChats">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Delete Chat History</h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="card-body">
                <p>{{ `Are you sure you want to delete the following chat(s)?` }}</p>
                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th class="w-25">Chat ID</th>
                            <th class="w-50">Title</th>
                            <th class="w-25">Craeted Time</th>
                            <th class="w-auto">User</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in chats" :key="item.resourceId">
                            <td>{{ item.resourceId }}</td>
                            <td>{{ item.title }}</td>
                            <td>{{ DateTimeFormat(splitCreatedTime(item.createdAt)) }}</td>
                            <td>{{ item.userId }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer d-flex justify-content-between align-items-center">
                <div>
                    <span class="text-danger" v-if="error">{{ `Error: ${error}` }}</span>
                </div>
                <button class="btn btn-danger">
                    <div v-if="deleteInProgress" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>
                        <slot></slot>Delete
                    </div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { DateTimeFormat } from '../../utils/commonFunction'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            chats: [],
            feature: "",
            deleteInProgress: false,
            error: "",
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "Delete Chat History",
    computed: {
        ...mapState({
            mmdChatLimit: state => state.amdp.mmdChatLimit,
            mmdAdminChatLimit: state => state.amdp.mmdAdminChatLimit,
            t2mdChatLimit: state => state.amdp.t2mdChatLimit,
            t2mdAdminChatLimit: state => state.amdp.t2mdAdminChatLimit,
        }),
    },
    methods: {
        ...mapActions({
            deleteChat: "amdp/deleteChat",
            getChats: "amdp/getChats",
        }), 
        async deleteChats() {
            if (!this.chats) return;

            this.deleteInProgress = true;
            this.error = "";
            try {
                const deletePromises = this.chats.map(item => {
                    return this.deleteChat({ feature: this.feature, resourceId: item.resourceId });
                });
                const results = await Promise.allSettled(deletePromises);

                let successfulDeletions = 0
                results.forEach((res, idx) => {
                    const chat = this.chats[idx];

                    if (res.status === "fulfilled") {
                        console.log(`Deleted conversation: ${chat.resourceId}`);
                        successfulDeletions++;
                    } else {
                        console.error(`Failed to delete conversation: ${chat.resourceId}\nReason: ${res.reason.response?.data}`);
                        let toastoptions = {
                            message: res.reason.response?.data || "Error deleteing conversation",
                            type: "error",
                        };
                        this.$store.dispatch('addToast', toastoptions);
                        this.error = "One or more delete(s) failed"
                    }
                });
                if (successfulDeletions == this.chats?.length) {
                    let toastoptions = {
                        message: "Chats(s) deleted successfully",
                        type: "success",
                    };
                    this.$store.dispatch('addToast', toastoptions);
                    this.$store.dispatch("hideModal");
                    if (this.feature == "map_my_data") {
                        if (this.modalData?.refreshChatsFunction && typeof this.modalData.refreshChatsFunction === 'function') {
                            this.modalData.refreshChatsFunction(true);
                        } else {
                            this.getChats({ feature: this.feature, limit: this.mmdChatLimit, forceGet: true });
                        }
                        if (this.$store.getters.userRoles.isAccessByRole([1, 1.5]))
                            this.getChats({ feature: this.feature, limit: this.mmdAdminChatLimit, adminHistory: true, forceGet: true });
                        if (this.$route.name == "Map My Data Specific Invocation") {
                            this.$router.push({ name: "All Map My Data Invocations" });
                        }
                    } else if (this.feature == "talk_to_my_data") {
                        if (this.modalData?.refreshChatsFunction && typeof this.modalData.refreshChatsFunction === 'function') {
                            this.modalData.refreshChatsFunction(true);
                        } else {
                            this.getChats({ feature: this.feature, limit: this.t2mdChatLimit, forceGet: true });
                        }
                        if (this.$store.getters.userRoles.isAccessByRole([1, 1.5]))
                            this.getChats({ feature: this.feature, limit: this.t2mdAdminChatLimit, adminHistory: true, forceGet: true });
                        if (this.$route.name == "Talk To My Data Specific Invocation") {
                            this.$router.push({ name: "All Talk To My Data Invocations" });
                        }
                    }
                }
            } catch (err) {
                console.error("Unexpected error while deleting chat history: ", err)
            } finally {
                this.deleteInProgress = false;
            }
        },
        splitCreatedTime(createdAt) {
            let createdTime = null;
            try {
                // split the createdAt string into "{cid}#{timestamp}"
                createdTime = createdAt.split('#')[1];
            } catch (error) {
                console.error("Error extracting created time: ", error);
            }
            return createdTime;
        },  
        DateTimeFormat
    },
    beforeMount() {
        this.chats = this.modalData?.chats;
        this.feature = this.modalData?.feature;
    }
};
</script>

<style scoped></style>